import TimeSvg from '../../../Assets/images/Activation/clock.svg';
import PeopleSvg from '../../../Assets/images/Activation/people.svg';
import PhoneSvg from '../../../Assets/images/Activation/phone.svg';
import SimCardSvg from '../../../Assets/images/Activation/simcard.svg';
import { globalVal } from '../../../global/globalvalues';

export const activationPage: any = {
    mainPage: {
        title: `Activating user's line`,
        points: [
            `Congrats! user's device is compatible with ${globalVal.long_name}.`,
            "Your device's IMEI (here’s how to find it).",
            "The 'Bring your number' information detailed in your Welcome Kit (skip this step for a new number).",
        ],
        eSimPoints: [
            'Your eSIM-compatible device.',
            "Your device's IMEI",
            "The 'Bring your number' information detailed in your eSIM Kit (skip this step for a new number).",
        ],
        note: 'A temporary hold will be placed on your credit card for the total value of the plan purchased',
        activateTitle: `How to activate your line on ${globalVal && globalVal.short_name}`,
        video: {
            url: 'https://d1w56w19nsq45n.cloudfront.net/videos/activation.mp4?autoplay=1',
            title: 'Watch the activation video',
        },
    },
    mainPageSecondary: {
        title: 'Activate Second’s line',
        subTitle: `Let’s get Second Line on ${globalVal && globalVal.short_name}! Here’s what you’ll need:`,
        points: [
            'A Welcome Kit and SIM card (one for each line)',
            'Phone IMEI',
            '"Bring your number" information detailed in your Welcome Kit (skip this for a new number)',
        ],
        tip: `Is Second Line bringing over their number? You’ll need their previous carrier account number, PIN, and billing zip code.`,
    },
    errorDefault: 'Oops!, Something went wrong. Please try again',
    errorPortValidate: `You seem to have entered an invalid number. ${globalVal &&
        globalVal.short_name} out to our Customer Success for help`,
    error5G:
        'Sorry! We are currently unable to support this 5G device. But we will be able to support 5G in the fall. Would to like to be notified once we support 5G.',
    notification5G:
        'Thank you for your interest. Our Customer Success will get in touch with you once we are 5G ready.',
    step1: {
        title: 'Verify Device Compatibility',
    },
    step2: {
        title: 'Number Preference',
        otherTitle: 'Previous Carrier Information',
    },
    step3: {
        title: 'Enter SIM Number',
        cardText: 'Please enter your SIM number.​',
        successMsg: 'Success! Your SIM card is valid.',
        error1: 'SIM Number is invalid.',
        error2:
            'That SIM Number is already in use or currently being activated. Please try another or contact Customer Success for help.',
        cardModal: {
            title: 'First bill hold',
            subtext: 'A temporary hold will be placed on your credit card for the total value of the plan purchased',
        },
        manageCard: {
            title: 'Manage card(s)',
            subtext: 'Your total balance will be charged in full on the of the month.',
            note:
                'Note: If we are unable to charge your default card, your payment will be processed on most recently added card, instead.',
        },
        orderSummaryModal: {
            title: 'Order Summary',
            subtext: 'Taxes & fees extra as applicable',
            note: 'Charges and taxes for this purchase, if applicable, will be in your upcoming invoice.',
        },
    },
    eSimIOSStep3: {
        title: "You're ready to go! Scan the QR code received in your inbox.",
        steps: [
            'Make sure you have your phone with you.',
            'Go to Settings, then Cellular.',
            'Select Add Cellular Plan.',
            'Open and point your camera at the QR code until you see Installing Cellular plan.',
            "You're all set! Your eSIM is now configured and ready to use.",
        ],
    },
    eSimAndroidStep3: {
        title: "You're ready to go! Scan the QR code received in your inbox.",
        steps: [
            'Make sure you have your phone with you.',
            'Go to Settings, then Connections.',
            'Click SIM Cards manager.',
            'Click Add mobile plan.',
            'If no plans are found on the screen, scan carrier QR code',
            "You're all set! Your eSIM is now configured and ready to use.",
        ],
    },
    step4: {
        title: `user's line is ready for Activation`,
        activationIsMnp: {
            title: "We're working on it!",
            subTitle: `We're contacting the carrier to switch {0}’s number over to ${globalVal &&
                globalVal.short_name}.`,
            content: [
                {
                    title: 'How long will it take?',
                    content: "Typically, this takes between 5 minutes to 2 hours. Any longer and we'll contact you.",
                    icon: TimeSvg,
                },
                {
                    title: 'Will my phone still work during the switch?',
                    content: `Yes, your current service will continue to work until your number transfers to ${globalVal &&
                        globalVal.short_name}.`,
                    icon: PhoneSvg,
                },
                {
                    title: 'Multiple lines?',
                    content: 'Additional lines can be activated once your activation is complete.',
                    icon: PeopleSvg,
                },
                {
                    title: 'When should I put in my SIM?',
                    content: 'Turn on push notifications so we can tell you when to insert the SIM card.',
                    icon: SimCardSvg,
                },
            ],
        },
        activationFail: {
            title: 'Activation failed!',
            subText: "We couldn't complete your activation.",
        },
        customerSupport: {
            email: 'reach@reachmobile.com',
            call: {
                contactdisplay: '(844) 445-3665',
                contact: '8444453665',
                time: '(Mon to Fri, ​9am to 9pm EST)​',
            },
            chat: '(24/7)',
        },
        imeiFail: {
            title: 'Device not supported',
            subTitle: `Unfortunately, we cannot activate ${globalVal &&
                globalVal.short_name} service on this device. Please contact our Customer Success Team for assistance.`,
            call: {
                contactdisplay: '(844) 445-3665',
                contact: '8444453665',
            },
        },
        notifymsg: 'Thank you for your interest. Our Customer Success will get in touch with you once we are 5G ready',
        fiveGText:
            'Sorry! We are currently unable to support this 5G device. But we will be able to support 5G in the fall. Would you like to be notified once we support 5G? ',
    },
    accordion: [
        {
            label: `On your mobile device`,
            description: [
                '1. Dial #P-O-R-T, enter in your 4 digit PIN.',
                '2. You will receive an SMS after you authenticate your account.',
                '3. Select the link provided, and your Number Transfer PIN is generated with an expiration date. Your account number will also be provided.',
            ],
        },
        {
            label: `On the {0} web page`,
            description: [
                '1. Visit your {0} account and view your profile.',
                '2. Click on "Number transfer PIN" and it will prompt you to click on "Generate PIN".',
                '*If you are a group member and someone within your group already generated a PIN, use the same code.',
            ],
        },
    ],
    portingMessage: {
        title: `Port In Unsuccessful`,
        numberPortingError: `Your port out request was rejected by your previous carrier due to incorrect account number. Please
        re-enter your correct account number (previous carrier's) and submit the request again.`,
        zipPortingError: `Your port out request was rejected by your previous carrier due to incorrect ZIP code. Please re-enter your correct ZIP code and submit the request again.`,
        pinPortingError: `Your port out request was rejected by your previous carrier due to incorrect PIN. Please re-enter your correct PIN and submit the request again.`,
        genericPortingError: `Your port out request was rejected by your previous carrier. Please get in touch with our Care Team to resolve this and submit your request again.`,
        customerCare: 'CALL 1.800.427.8686',
        accNumberTitle: 'RE-ENTER ACCOUNT NUMBER',
        zipCodeTitle: 'RE-ENTER ZIP CODE',
        pinTitle: 'RE-ENTER PIN',
        inProgress: 'Porting in Progress',
        success: 'Port in Successful',
    },
};
